export enum URLParameters {
  PAGE_TYPE = 'pageType',
  ORIGIN = 'origin',
  ORIGIN_TYPE = 'originType',
  DESTINATION = 'destination',
  DESTINATION_TYPE = 'destinationType',
  DATE_FROM = 'dateFrom',
  DATE_TO = 'dateTo',
  ADULTS = 'adults',
  AGES = 'ages',
  FLIGHT_CLASS = 'flightClass',
  HOTEL_ID = 'hotelId',
  SEARCH_ID = 'searchId',
  HDP_SEARCH_ID = 'hdpSearchId',
  VC_SEARCH_ID = 'vcSearchId',
  SEARCH_MODE = 'searchMode',
  SEARCH_TYPE = 'searchType',
  SOURCE = 'source',
  SUBSOURCE = 'subsource',
  BF_SUB_SOURCE = 'bfSubSource',
  BF_SUB_SOURCE_VARIANT_1 = 'bf_SubSource',
  BF_SUB_SOURCE_VARIANT_2 = 'bf_subsource',
  SORT = 'sort',
  OFFSET = 'offset',
  PAGE = 'page',
  MAP_AREA = 'map_area',
  HIGHLIGHT_HOTEL_ID = 'highlightHotelId',
  ABTEST = 'crs_ab',
  TRAFFIC_SOURCE = 'crs_source',
  TRAFFIC_SUBSOURCE = 'crs_subsource',
  ALTERNATIVE_ACCOMODATION = 'filters_alt_accomod',
  BUSINESS_PROFILE_ID = 'businessProfileId',
  DEBUG = 'debug',
  // selects a mocked-endpoint scenario from /debug/scenarios (auth-gated, non-prod + authenticated only)
  DEBUG_SCENARIO = 'debugScenario',
  // dates used in hotel details page
  TRIP_DATES = 'departureIntervals',
  // dates used in hotel details page, sometimes comes with different format from metas
  TRIP_DATES_LEAD_TIME = 'leadTime',
  TRIP_DATES_LENGTH_OF_STAY = 'lengthOfStay',
  TRIP_DATES_CHECKIN_ON_DAY = 'checkInOnDay',
  // ProviderId used in checkout backUrl param to exclude the provider in case of error
  CHECKOUT_BACK_KOPROVIDER_ID = 'backKoProviderId',
  // backKoProviderId is converted to koProviderId to keep it in the url to continue excluding it in case of refresh or sharing the url
  KOPROVIDER_ID = 'koProviderId',
  // error type from checkout
  CHECKOUT_ERROR_TYPE = 'errorType',
  // meta param sent to the pricing endpoints to manage the price absorption
  FEED_CONTEXT = 'feedContext',
  // TransportID used in flights prefilters in hotel details page
  TRANSPORT_ID = 'transportId',
  // transport stops used in flights prefilters in hotel details page
  STOPS = 'stops',
  // transport airline used in flights prefilters in hotel details page
  AIRLINE = 'airline',
  // meal plan prefilter used in hotel details page
  MEALPLAN = 'mealplan',
  // provider id used to force provider in rooms pricing endpoint
  PROVIDER = 'provider',
  // room id used in review page to know the selected room
  ROOM_ID = 'roomId',
  // mealPlan id used in review page to know the selected meal plan
  MEALPLAN_ID = 'mealPlanId',
  // mealPlan code used in review page to know the selected meal plan based on board type and cancellation.
  // The meal plan id is refreshed every time rooms endpoint is called so it is only valid in the normal flow,
  // to find the selected meal plan when using deep links or refreshing the page it is needed to search by this code
  MEALPLAN_CODE = 'mealPlanCode',
  BRANDED_FARE_ID = 'brandedFareId',
  CHECKIN = 'checkin',
  CHECKOUT = 'checkout',
  IAND = 'iand',
  FILTER_BY_PROVIDER = 'filterByProvider',
  APP = 'app',
  APPVIEW = 'appview',
  EXT_REFERENCE_ID = 'extReferenceId',
  EXT_REFERENCE_TYPE = 'extReferenceType',
  FEATURE_TOGGLES = 'ft',
  // limit used when clicking dot on map to call Products with only one result
  LIMIT = 'limit',
  ADD_DAYS = 'adddays',
  APEX_FLEXIBLE_DAYS = 'apex_flexible_days',
  META_CLICK_OUT_ID = 'metaclickoutid',
  VIEW_MODE_DESKTOP = 'viewMode',
  COMPARE_IDS = 'compareIds',
  // totalPrice used in searchRequest Startrack event - but is it ever populated in the Query String?
  TOTAL_PRICE = 'totalPrice',
  LEISURE = 'leisure_type',
  PRICE = 'price',
  OUTBOUND_CONNECTIONS = 'outbound_connections',
  RETURN_CONNECTIONS = 'return_connections',
  AIRLINES = 'airlines',
  OUTBOUND_DEPARTURE_AIRPORTS = 'outbound_departure_airports',
  OUTBOUND_ARRIVAL_AIRPORTS = 'outbound_arrival_airports',
  RETURN_DEPARTURE_AIRPORTS = 'return_departure_airports',
  RETURN_ARRIVAL_AIRPORTS = 'return_arrival_airports',
  DEPARTURE_TIME_OUTBOUND = 'outbound_departure_time',
  DEPARTURE_TIME_RETURN = 'return_departure_time',
  FLIGHT_DURATION = 'flight_duration',
  DEPARTURE_FLIGHTS = 'departure_flights',
  RETURN_FLIGHTS = 'return_flights',
  TRAVEL_FLEXIBILITY = 'travel_flexibility',
  STARS = 'hotel_stars',
  MEAL = 'meal',
  DIRECT = 'direct',
  RATING = 'rating',
  FLASH_SALES = 'flash_sales',
  PINK_PEOPLE = 'pinkpeople',
  ACCOMODATION_TYPE = 'accomodation_type',
  ACCOMODATION_FACILITIES = 'accomodation_facilities',
  GENERAL_ACCOMODATION_FACILITIES = 'general_accomodation_facilities',
  FAMILY_ACCOMODATION_FACILITIES = 'family_accomodation_facilities',
  ACTIVITY_ACCOMODATION_FACILITIES = 'activity_accomodation_facilities',
  WELLNESS_ACCOMODATION_FACILITIES = 'wellness_accomodation_facilities',
  FOOD_ACCOMODATION_FACILITIES = 'food_accomodation_facilities',
  FACILITIES = 'facilities',
  FREE_CANCELLATION = 'free_cancellation',
  BOOK_NOW_PAY_LATER = 'book_now_pay_later',
  TOP_SECRET_HOTEL = 'tsh',
  BLUE_FLAG = 'blue_flag',
  SUSTAINABILITY_CERTIFICATE = 'sustainability_certificate',
  BEACH_TYPE = 'beach_type',
  CLIMATE = 'climate',
  FAUNA = 'fauna',
  WATERSPORT = 'watersport',
  ENTERTAINMENTS = 'entertainments',
  WATER_WAVES = 'waterwaves',
  PRE_FILTER_DESTINATION_AIRPORT = 'prefilter_destination_airport',
  PRE_FILTER_AIRLINES = 'prefilter_airlines',
  OVERNIGHT_FLIGHTS = 'overnight_selected',
  MY_PRICE = 'myprice',
  ACCOMODATION_CHAIN = 'accomodation_chain',
  ACCOMODATION_DISTRICT = 'accomodation_district',
  ACCOMODATION_BEACH = 'accomodation_beach',
  ACCOMODATION_SKILIFT = 'accomodation_skilift',
  ACCOMODATION_STATION = 'accomodation_station',
  ACCOMODATION_THEME = 'accomodation_theme',
  ACCOMODATION_NAME = 'accomodation_name',
  FILTER_VOUCHER_EXTRA = 'filterVoucherExtra',
  CUSTOM_CHECKIN_CHECKOUT = 'prefilter_checkin_checkout',
  FILTER_OPX_FLEXIBLE = 'filter_opx_flexible',
  ALLOW_DESKTOP = 'allow-desktop',
  // Param used in history navigation to know if a modal is opened
  MODAL = 'modal',
  HOST_NAME = 'hostname',
  MS_CURRENCY = 'msCurrency',
  MS_TOTAL_PRICE = 'msTotalPrice',
  MS_MEAL_PLAN = 'msMealPlan',
  SKYSCANNER_REDIRECTID = 'skyscanner_redirectid',
  // This is the clickId generated when clicking on a card on the results page. It is used to track the click on the card and the hotel details shown in the details page
  CLICK_ID = 'clickId',
  // [SLIDERS-999]
  LIMITED_INVENTORY = 'limInv', // value: '1'
  // This is for metas, requested by Duff
  INTERNAL_ID_TRANSPORT = 'internalIdTransport',
  // AB test CSW
  AB_TEST_NAME = 'abTestName',
  AB_TEST_VARIANT = 'abTestVariant',
  // This is for alternative ways of going to the hotel details page
  RESULT_VIEWED_OTHER = 'result_viewed_other',
  // To avoid hydration errors, this is not using the timestamp and the clickId is created in the middleware
  PRE_CLICK_ID = 'pre_click_id',
  // Used in middleware. Sets "__mpt" cookie value, gets removed from the url. Used by App when moving from native to webview as there is
  // a problem with cookies not being always passed.
  MPT = 'mpt',
  // this param can be present twice in URL, in this case prioritize the one with the value "yes"
  AFFILIATE = 'affiliate',
  // Meta params to identify if the visit comes from meta search engines
  META = 'meta',
  GMETA = 'gmeta',
  RATE_APEX = 'rapex', // when  memsearch rate.flags.apex=true. To send in deep link to Details page
  RATE_PRICE_CONTEXT = 'rctx', // find good name? price_context seems too explicit to put in URL
  RATE_PRICE_CONTEXT_SIGNATURE = 'rsign',
  SEED = 'seed', // See value read from Casper and added to the url to preserve AB Test variants when sharing urls etc.
  FILTER_LOYALTY_DEALS = 'filter_loyalty_deals',
  // To identify that the user is coming from a card click
  CLICK_ON_CARD = 'click_on_card',
  // Set on the results→detail deeplink when the clicked card showed the kids-stay-free badge; consumed and
  // stripped on the detail page to gate the CUX 3966 filter. Absent on deep links / after strip (share/reload).
  FROM_KIDS_FREE_BADGE = 'fromKidsFreeBadge',
  DEFERRED_PAYMENTS = 'deferredPayments',
  COUNTRY = 'country',
  ID = 'id',
  CATEGORY = 'category',
  INTERNAL_HOTEL_ID = 'internalHotelId',
  HOTEL_CITY = 'hotelCity',
  AUTH = 'auth',
  // Cart renewal (MPH-394): params sent by OBE on the renewUrl to rebuild the cart on return
  RENEW = 'renew',
  CART_ID = 'cartId',
  SELECTION_ID = 'selectionId',
  TOUCH_POINT = 'touchPoint',
}

export const PERSISTENT_FILTER_PARAMS: URLParameters[] = [
  URLParameters.CUSTOM_CHECKIN_CHECKOUT,
  URLParameters.FILTER_OPX_FLEXIBLE,
];

// Detail-page selection params must not survive back to the results page: otherwise reopening the
// same hotel re-seeds the previously chosen transport, branded fare, room and meal plan instead of
// the default cheapest offer (SelectedMealPlanProvider matches roomId against roomOfferId, and a
// stale mealPlanCode still matches the new offers by code). The APEX price-absorption params are a
// per-hotel detail concern and must not leak into the results URL either (MPH-634).
export const DETAIL_ONLY_PARAMS = [
  URLParameters.TRANSPORT_ID,
  URLParameters.BRANDED_FARE_ID,
  URLParameters.ROOM_ID,
  URLParameters.MEALPLAN_ID,
  URLParameters.MEALPLAN_CODE,
  URLParameters.CLICK_ID,
  URLParameters.LIMITED_INVENTORY,
  URLParameters.RATE_APEX,
  URLParameters.RATE_PRICE_CONTEXT,
  URLParameters.RATE_PRICE_CONTEXT_SIGNATURE,
];

export const ADULTS_DEFAULT = 2;
